import { AreaCardData, AreaInfo } from 'ais-facade-api/api';

import { WKTLoader } from '@loaders.gl/wkt';
import { parseSync } from '@loaders.gl/core';

export const getAreaBounds = (area: AreaCardData | AreaInfo): number[] | null => {
  if (!('geometry' in area) || !area.geometry) return null;

  // Знаки расставлены верно. Цель - при сравнении реальных координат геозоны необходимо иметь значение,
  // которое гарантировано перекроется координатой.

  let minLng = Infinity;
  let maxLng = -Infinity;
  let minLat = Infinity;
  let maxLat = -Infinity;

  const checkMultiPolygon = (multyPolygon: number[][][][]) => {
    multyPolygon.map((polygon: number[][][]) => {
      polygon.forEach((coordinates: number[][]) => {
        coordinates.map(([lng, lat]: number[]) => {
          minLng = Math.min(minLng, lng);
          maxLng = Math.max(maxLng, lng);
          minLat = Math.min(minLat, lat);
          maxLat = Math.max(maxLat, lat);
        });
      });
    });
  };

  const checkWktGeometry = (geometry: any, coordinatesArray: number[] | number[][][] | number[][][][]) => {
    if (geometry.type === 'Point') {
      minLng = (coordinatesArray as number[])[0];
      maxLng = (coordinatesArray as number[])[0];
      minLat = (coordinatesArray as number[])[1];
      maxLat = (coordinatesArray as number[])[1];
    }
    if (geometry.type === 'Polygon' || geometry.type === 'MultiLineString') {
      (coordinatesArray as number[][][]).map((array: number[][]) => {
        array.forEach(([lng, lat]: number[]) => {
          minLng = Math.min(minLng, lng);
          maxLng = Math.max(maxLng, lng);
          minLat = Math.min(minLat, lat);
          maxLat = Math.max(maxLat, lat);
        });
      });
    }
    if (geometry.type === 'MultiPolygon') {
      checkMultiPolygon(coordinatesArray as number[][][][]);
    }
  };

  const geometry = parseSync(area.geometry, WKTLoader);
  if (geometry && 'coordinates' in geometry) {
    const { coordinates: coordinatesArray } = geometry;
    checkWktGeometry(geometry, coordinatesArray);
  }
  if (geometry && 'geometries' in geometry) {
    if (geometry.type === 'GeometryCollection') {
      geometry.geometries.map((collectionItem: any) => {
        const { coordinates: coordinatesArray } = collectionItem;
        checkWktGeometry(collectionItem, coordinatesArray);
      });
    }
  }
  const bounds = [minLng, minLat, maxLng, maxLat];
  return bounds;
};
